import { isPlainObject } from "@shared/lib/type-guards/is-plain-object";

export const isStoreFilter = (value: unknown) =>
  isPlainObject(value) && typeof value.region === "string";
